import { useAtom } from 'jotai';
import { memo, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useActionEmailData } from '@/src/modules/CampaignsModule/hooks/useActionEmailData';

import { htmlEditorActionDisabledAtom } from './atoms/htmlEditorAtom';
import { ModalUpload } from './components/ModalUpload/ModalUpload';
import EditPage from './pages/EditPage';
import HeaderSection from './HeaderSection';

import { useHiddenV1Container } from '@/modules/AutomationModuleNew/hooks/useHiddenV1Container';

interface IHtmlEditorProps {
  isAutomationModule?: boolean;
}

const HtmlEditor = memo(({ isAutomationModule = false }: IHtmlEditorProps) => {
  useHiddenV1Container();
  const { actionId } = useParams();

  const [disabled, setDisabled] = useAtom(htmlEditorActionDisabledAtom);

  const { getEmailInfo } = useActionEmailData(Number(actionId));
  useEffect(() => {
    void getEmailInfo();
  }, [getEmailInfo, setDisabled]);

  useEffect(() => {
    return () => {
      setDisabled(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[calc(100vh_-_64px)] bg-emblue-white">
      <HeaderSection disabled={disabled} isAutomationModule={isAutomationModule} />
      <div className="p-10">
        <EditPage />
      </div>
      <ModalUpload />
    </div>
  );
});

export default HtmlEditor;
